import { createContext } from 'react';

/**
 * Thrown by `toggleGlow` when Glow can't turn on because there's no location
 * fix yet — either the browser prompt is still pending or the user has blocked
 * the site. The message is already user-facing; `GlowPill` toasts it verbatim.
 */
export class GlowLocationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'GlowLocationError';
  }
}

export interface GlowContextValue {
  glowOn: boolean;
  glowExpiresAt: string | null;
  /** Auto-detecting/checking into a Spot in response to a Glow-on tap. */
  resolving: boolean;
  /** Consecutive heartbeats reporting we've left the checked-in Spot. */
  outOfArea: number;
  spotName: string | null;
  locationBlocked: boolean;
  /** Current GPS accuracy in metres (lower = sharper), or null before a fix. */
  gpsAccuracy: number | null;
  toggleGlow: () => Promise<void>;
}

export const GlowContext = createContext<GlowContextValue | null>(null);
